import clsx from 'clsx';
import React from 'react';
import buttons from '../css/buttons.module.scss';
import styles from '../css/landing.module.scss';
import { MIXPANEL_EVENTS } from '../utils/mixpanel-consts';
import { track } from '../utils/mixpanel-helper';

type CtaButtonProps = {
  position?: string;
  label?: string;
  isDisabled: boolean;
  toggleCheckEmailModal: () => void;
  classNames?: string;
};

const CtaButton = React.memo(function CtaButton({
  isDisabled,
  toggleCheckEmailModal,
  label,
  classNames,
  position,
}: CtaButtonProps): JSX.Element {
  return (
    <button
      disabled={isDisabled}
      className={clsx(styles.cta, buttons.buttonOutlined, classNames)}
      onClick={() => {
        toggleCheckEmailModal();
        track(MIXPANEL_EVENTS.BUTTON_CLICK, {
          button: 'init-signup',
          label,
          position,
        });
      }}
    >
      {label || 'Let’s Do It!'}
    </button>
  );
});

export default CtaButton;
